import React, { useEffect, useState } from "react";
import TableInc from "../../../../../../shared-ui/TableInc";
import { updateExtendedConfig } from "../../../../../../lib/requests.es6";
import { getPartner } from "../../../../../../lib/access.es6";

const MainInsuranceScheme = (props) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (props.membership_configs && props.membership_configs.content) {
      const packages = props.membership_configs.content.packages || [];
  
      const mappedData = packages.map((packag) => ({
        scheme: packag.scheme || "N/A",
        sumAssured: packag.sumAssured || 0,
        individualPremium: packag.individualPremium || 0,
        familyPremium: packag.familyPremium || 0,
        scopeOfCover: Array.isArray(packag.scopeOfCover) ? packag.scopeOfCover : [], 
      }));
  
      setData(mappedData);
    } else {
      setData([]); 
    }
  }, [props.membership_configs]);
  

  const updateMembershipConfigs = async (newData) => {
 

    const payload = {
      product_guid: props.productGuid,
      ...props.membership_configs,
      content: {
        ...props.membership_configs.content,
        packages: newData,
      },
    };
   await updateExtendedConfig(payload)
   window.location.reload(true);
    console.log("Updated Payload:", payload);
  };
 const currencyCode = getPartner().country.currency_code
  return (
    <TableInc
      title="Main Insurance Scheme"
      columns={[
        { title: "Scheme", field: "scheme" },

        {
          title: 'Sum Assured', field: 'sumAssured', type: 'numeric', render: rowData => <>
            {
              currencyCode + " " + (rowData.sumAssured).toLocaleString('en')
            } </>
        },
        {
          title: 'Individual Premium', field: 'individualPremium', type: 'numeric', render: rowData => <>
            {
              currencyCode + " " + (rowData.individualPremium).toLocaleString('en')
            } </>
        },
        {
          title: 'Family Premium', field: 'familyPremium', type: 'numeric', render: rowData => <>
            {
              currencyCode + " " + (rowData.familyPremium).toLocaleString('en')
            } </>
        },

      ]}
      data={data}
      options={{
        addRowPosition: "first",
        showTitle: true,
        actionsColumnIndex: -1,
        pageSize: data.length > 0 ? data.length : 5, 
      }}
      editable={{
        onRowAdd: (newData) =>
          new Promise((resolve) => {
            const newEntry = {
              ...newData,
              scopeOfCover: [], 
              familyPremium: Number(newData.familyPremium) || 0,
              individualPremium: Number(newData.individualPremium) || 0,
              sumAssured: Number(newData.sumAssured) || 0,
            };
        
            const newDataArray = [...data, newEntry];
            setData(newDataArray);
            updateMembershipConfigs(newDataArray);
            resolve();
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            const dataUpdate = [...data];
            const index = oldData.tableData.id;
            dataUpdate[index] = newData;
            setData(dataUpdate);
            updateMembershipConfigs(dataUpdate);
            resolve();
          }),
        onRowDelete: (oldData) =>
          new Promise((resolve) => {
            const dataDelete = [...data];
            const index = oldData.tableData.id;
            dataDelete.splice(index, 1);
            setData(dataDelete);
            updateMembershipConfigs(dataDelete);
            resolve();
          }),
      }}
      detailPanel={(rowData) => (
        <TableInc
          title="Scope of Cover"
          columns={[{ title: "Coverage", field: "coverage" }]}
          data={
            rowData.scopeOfCover 
              ? rowData.scopeOfCover.map((coverage) => ({ coverage })) 
              : []
          }
          options={{
            pageSize: rowData.scopeOfCover ? rowData.scopeOfCover.length : 1,
            showTitle: true,
            actionsColumnIndex: -1,
            addRowPosition: "first",
          }}
          editable={{
            onRowAdd: (newData) =>
              new Promise((resolve) => {
                const updatedData = [...data];
                const index = rowData.tableData.id;
                updatedData[index].scopeOfCover.push(newData.coverage);
                console.log("updatedData", updatedData);
                setData(updatedData);
                updateMembershipConfigs(updatedData);
                resolve();
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                const updatedData = [...data];
                const index = rowData.tableData.id;
                updatedData[index].scopeOfCover = updatedData[
                  index
                ].scopeOfCover.filter((item) => item !== oldData.coverage);
                setData(updatedData);
                updateMembershipConfigs(updatedData);
                resolve();
              }),

              // onRowUpdate: (newData, oldData) =>
              //   new Promise((resolve) => {
              //     setData((prevData) => {
              //       const updatedData = [...prevData];
              
              //       // Find the correct row using scheme name (or another unique identifier)
              //       const rowIndex = updatedData.findIndex((item) => item.scheme === rowData.scheme);
              
              //       console.log("Row index found:", rowIndex);
              
              //       if (rowIndex === -1) {
              //         console.error("Row not found for update.");
              //         resolve();
              //         return prevData;
              //       }
              
              //       // Ensure scopeOfCover exists
              //       updatedData[rowIndex].scopeOfCover = updatedData[rowIndex].scopeOfCover
              //         ? updatedData[rowIndex].scopeOfCover
              //         : [];
              
              //       // Find and replace the coverage entry
              //       const coverageIndex = updatedData[rowIndex].scopeOfCover.findIndex(
              //         (item) => item === oldData.coverage
              //       );
              
              //       coverageIndex !== -1
              //         ? (updatedData[rowIndex].scopeOfCover[coverageIndex] = newData.coverage)
              //         : console.warn("Coverage not found for update.");
              
              //       console.log("Final updated data before setState:", updatedData);
              //       return updatedData;
              //     });
              
              //     setTimeout(() => {
              //       // Ensure extendedConfig and content exist before accessing them
              //       const updatedPayload = {
              //         product_guid: props.productGuid,
              //         ...(props.extendedConfig ? props.extendedConfig : {}), // Ensure extendedConfig exists
              //         content: {
              //           ...(props.extendedConfig && props.extendedConfig.content 
              //             ? props.extendedConfig.content 
              //             : {}), // Ensure content exists
              //           packages: data, // Ensure latest state is used
              //         },
              //       };
                    
              
              //       console.log("Updated Payload:", updatedPayload);
              
              //       updateMembershipConfigs(updatedPayload)
              //         .then(() => resolve())
              //         .catch((err) => {
              //           console.error("Update failed:", err);
              //           resolve();
              //         });
              //     }, 100);
              //   }),
              
              
              
              
          }}
        />
      )}
    />
  );
};

export default MainInsuranceScheme;
